import { BackendService } from './backend.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
/**
 * Service that handles the authorization of users
 */
var AuthService = (function () {
    /**
     * Constructor
     */
    function AuthService(backendService, snackBar, translate) {
        this.backendService = backendService;
        this.snackBar = snackBar;
        this.translate = translate;
        /**
         * JWT Authentication token
         */
        this.token = '';
        this.loggedIn = new BehaviorSubject(false);
        this.token = localStorage.getItem('UserToken') || '';
        this.loggedIn.next(this.isLoggedIn());
    }
    /**
     * Checks if user is logged in
     * @returns {boolean} True if user is logged in
     */
    AuthService.prototype.isLoggedIn = function () {
        return this.token !== '' && this.token !== null;
    };
    /**
     * Logs in user with given email and password
     * @param {string} email Email
     * @param {string} password Password
     * @returns {Promise<any>} Response as Promise
     */
    AuthService.prototype.login = function (email, password) {
        var _this = this;
        return this.backendService
            .post('auth/login', {
            email: email,
            password: password,
        })
            .then(function (response) {
            localStorage.setItem('UserToken', response.token);
            _this.token = response.token || '';
            _this.loggedIn.next(_this.isLoggedIn());
            return response;
        });
    };
    /**
     * Log in an user using an auth token
     * @param {string} token
     */
    AuthService.prototype.loginWithToken = function (token) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.backendService
                .post("auth/login/" + token)
                .then(function (response) {
                if (response.token) {
                    localStorage.setItem('UserToken', response.token);
                    _this.token = response.token || '';
                    _this.loggedIn.next(_this.isLoggedIn());
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            })
                .catch(function (error) {
                _this.translate.get('LOGIN.authTokenLoginError').subscribe(function (text) {
                    _this.snackBar.open(text, null, {
                        verticalPosition: 'top',
                        duration: 4000,
                        panelClass: ['b2a-error', 'top'],
                    });
                });
                reject(error);
            });
        });
    };
    /**
     * Logs out user
     */
    AuthService.prototype.logout = function () {
        this.token = null;
        this.loggedIn.next(this.isLoggedIn());
        localStorage.removeItem('UserToken');
    };
    /**
     * Step 1 / 3
     * Sends a registration request for the specified email adress with the given password, language preference and activation token.
     * This will send a confirmation email to the users email address.
     * @param email
     * @param password
     * @param lan
     * @param token
     * @param boToken
     * @param selectTeamAfterRegistration - Whether user should be redirected to team selection after first login
     */
    AuthService.prototype.registerUser = function (email, password, lan, token, boToken, selectTeamAfterRegistration) {
        var body = {
            email: email,
            password: password,
            language: lan,
        };
        if (selectTeamAfterRegistration) {
            body.selectTeamAfterRegistration = true;
        }
        return this.backendService.post("auth/register/" + token + "/" + boToken, body);
    };
    /**
     * requests an activation email to be resend for an already registered but inactive user
     * @param email
     */
    AuthService.prototype.resendActivationEmail = function (email) {
        return this.backendService.post('auth/activation/mail', { email: email });
    };
    /**
     * Sends a verification request for a given confirmation token, obtained through a registration email sent in step 1.
     * This should return all relevant information to complete the next step. (Company and language Details)
     * @param token
     */
    AuthService.prototype.getCompanyByVerificationToken = function (token) {
        return this.backendService.get('companies/' + token);
    };
    /**
     * Activates a user identified by the token sent in step 1/2. Also sets some of the user's settings.
     * @param branchofficeID
     * @param gender
     * @param firstName
     * @param lastName
     * @param token
     */
    AuthService.prototype.activateAccount = function (branchofficeID, gender, firstName, lastName, token) {
        var _this = this;
        return this.backendService
            .post('auth/activate/' + token, {
            branchofficeId: branchofficeID,
            gender: gender,
            firstName: firstName,
            lastName: lastName,
        })
            .then(function (response) {
            localStorage.setItem('UserToken', response.token);
            _this.token = response.token || '';
            _this.loggedIn.next(_this.isLoggedIn());
            return response;
        });
    };
    return AuthService;
}());
export { AuthService };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/auth.service.ts.pre-build-optimizer.js